<template>
    <div id="appIndex">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="appIndex_banner">
                <div class="back_icon"
                     @click="goBack"></div>
            </div>
            <div class="subject_list">
                <div class="list">
                    <!-- 小学语文期末测试一 -->
                    <div v-if="yw1.length"
                         class="item">
                        <div class="list_title">
                            <p><span>语文</span>阶段性测评（一）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in yw1"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/chinese/inspect/preview/task/'+item.paper_id+'?hd_type='+hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="yw2.length"
                         class="item">
                        <div class="list_title">
                            <p><span>语文</span>阶段性测评（二）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in yw2"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/chinese/inspect/preview/task/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                    <!-- 小学数学期末测试一 -->
                    <div v-if="sx1.length"
                         class="item">
                        <div class="list_title">
                            <p><span>数学</span>阶段性测评（一）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in sx1"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                    <!-- 小学数学期末测试一 -->
                    <div v-if="sx2.length"
                         class="item">
                        <div class="list_title">
                            <p><span>数学</span>阶段性测评（二）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in sx2"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                    <!-- 初中数学期末测试一a -->
                    <div v-if="msx1.length"
                         class="item">
                        <div class="list_title">
                            <p><span>初中数学</span>阶段性测评（一）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in msx1"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                    <!-- 初中数学期末测试二 -->
                    <div v-if="msx2.length"
                         class="item">
                        <div class="list_title">
                            <p><span>初中数学</span>阶段性测评（二）</p>
                        </div>
                        <div class="unit_list">
                            <div class="list_item"
                                 v-for="(item,index) in msx2"
                                 :key="index">
                                <div class="unit_name ellipsis">{{item.unit_name}}</div>
                                <router-link class="preview_btn"
                                             :to="'/preview/task/21/'+item.paper_id+ '?hd_type=' + hd_type">预览</router-link>
                                <button class="share_btn"
                                        @click="share(item)">分享给学生</button>
                                <button class="go_detail"
                                        @click="goDetail(item)">查看完成情况</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            hd_type: 9,//本次活动type
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            unitData: {},
            yw1: [],//语文试卷一
            yw2: [],//语文试卷二
            sx1: [],//小学数学试卷一
            sx2: [],//小学数学试卷二
            msx1: [],//初中小学数学试卷一
            msx2: [],//初中数学试卷二
        }
    },
    created () {
        //修改页面标题
        window.document.title = "阶段性测评"
        this.$http.post(API_URL_HD_API + "/common/get_paper", {
            hd_type: this.hd_type
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.unitData = res.data
                res.data.yw_paper.forEach(e => {
                    if (e.sid == 51 && e.sequence == 1) {
                        this.yw1.push(e)
                    }
                    if (e.sid == 51 && e.sequence == 2) {
                        this.yw2.push(e)
                    }
                })
                res.data.sx_paper.forEach(e => {
                    if (e.dept_type == 1 && e.sequence == 1) {
                        this.sx1.push(e)
                    }
                    if (e.dept_type == 1 && e.sequence == 2) {
                        this.sx2.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 1) {
                        this.msx1.push(e)
                    }
                    if (e.dept_type == 2 && e.sequence == 2) {
                        this.msx2.push(e)
                    }
                })
                if (this.yw1.length < 1 && this.yw2.length < 1 && this.sx1.length < 1 && this.sx2.length < 1 && this.msx1.length < 1 && this.msx2.length < 1) {
                    layer.alert('暂无试卷')
                }

            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        share (unit) {
            let that = this
            let title = unit.school_name + (unit.sid == 21 ? "数学" : "语文") + "阶段性测评";
            let content = "点击参加" + (unit.sid == 21 ? "数学" : "语文") + "阶段性测评";
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${unit.wap_url},${String(unit.sid)[0]},${unit.unit_class_id},0,26,阶段性测评活动分享`);
            } else {
                layer.alert('将链接分享到对应的班级群，点击链接即可参加阶段性测评。', 'tea', function (index) {
                    that.copyText(`${title},${content},链接：${unit.wap_url}`)
                    layer.close(index)
                }, '分享链接复制成功')

            }

        },
        goDetail (u) {
            this.$store.commit('setTabtype', 1)
            this.$router.push(`/personaLearning?sid=${u.sid}&taskId=${u.paper_id}&classId=${u.unit_class_id}&hd_type=${this.hd_type}&dept_type=${u.dept_type}&className=${encodeURIComponent(u.unit_name)}`)
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#appIndex {
    min-height: 737px;
    max-width: 720px / $ppr;
    overflow: hidden;
    background: #5591ff;
    .appIndex_banner {
        height: 920px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/banner.jpg");
        position: relative;
        .back_icon {
            position: absolute;
            width: 64px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_01.png");
            cursor: pointer;
        }
    }
    .subject_list {
        padding: 0 32px / $ppr;
        margin: 106px / $ppr 0;
        .list {
            position: relative;
            margin-bottom: -50px / $ppr;
            margin-top: -70px / $ppr;
        }
        .item {
            border-radius: 30px / $ppr;
            margin-bottom: 63px / $ppr;
            background-color: #163ec4;
            background: linear-gradient(to right, #d2eaff 0%, #fae9ed 100%);

            .list_title {
                text-align: center;
                margin-right: -20px / $ppr;
                p {
                    display: inline-block;
                    height: 108px / $ppr;
                    line-height: 108px / $ppr;
                    font-size: 36px / $ppr;
                    color: #212c4b;
                    font-weight: bold;
                    position: relative;
                    z-index: 9;
                    &:after {
                        content: "";
                        width: 100%;
                        height: 16px / $ppr;
                        left: -10px / $ppr;
                        right: 16px / $ppr;
                        bottom: 30px / $ppr;
                        z-index: -1;
                        border-radius: 8px / $ppr;
                        position: absolute;
                        background-color: #9bcaff;
                        background: linear-gradient(
                            to right,
                            #9bcaff 0%,
                            #f3d4b8 100%
                        );
                    }
                    span {
                        color: #2559c2;
                    }
                }
            }
            .unit_list {
                padding: 40px / $ppr 22px / $ppr 22px / $ppr;
                border-radius: 30px / $ppr;
                background: #f1fcff;
                .list_item {
                    display: flex;
                    background-color: #e9f6ff;
                    border-radius: 12px / $ppr;
                    height: 130px / $ppr;
                    margin-bottom: 24px / $ppr;
                    align-items: center;
                    padding: 0 18px / $ppr 0 28px / $ppr;
                    .unit_name {
                        flex-grow: 1;
                        font-size: 28px / $ppr;
                        color: #333;
                        font-weight: bold;
                        overflow: hidden;
                    }
                    .preview_btn {
                        text-align: center;
                        font-size: 28px / $ppr;
                        color: #2b6ad1;
                        flex-shrink: 0;
                        position: relative;
                        padding-right: 28px / $ppr;
                    }
                    button {
                        height: 56px / $ppr;
                        line-height: 56px / $ppr;
                        border-radius: 56px / $ppr;
                        border: none;
                        color: #fff;
                        font-size: 24px / $ppr;
                        &.share_btn {
                            width: 156px / $ppr;
                            margin-right: 16px / $ppr;
                            background-color: #4e84fb;
                            background: linear-gradient(
                                to top,
                                #4e84fb 0%,
                                #73b2ff 100%
                            );

                            box-shadow: 0px 5px 7px 0px rgba(47, 82, 220, 0.2);
                        }
                        &.go_detail {
                            width: 180px / $ppr;
                            color: #783d18;
                            background-color: #fbc626;
                            background: linear-gradient(
                                to top,
                                #fbc626 0%,
                                #fdf178 100%
                            );
                            box-shadow: 0px 5px 7px 0px rgba(190, 141, 7, 0.22);
                        }
                    }
                }
            }
        }
    }
}
</style>